import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import Fly from "../../../assets/img/Featured/fly-tap-pay-tall.png";
import Reserve from "../../../assets/img/Featured/app-reservations-tall.png";
import OnDemand from "../../../assets/img/Featured/app-ondemand-food-tall.png";
import SmartMenu from "../../../assets/img/Featured/app-order-menu-tall.png";
import QuickPay from "../../../assets/img/Featured/app-qr-quickpay-tall.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useCallback } from "react";
import { useData } from "../../../context/DataProvider";
import { Header } from "../../../components/Header";

const RestaurantPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page restaurantPage">
            <Header />
            <div className="page-header">On Site Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Restaurant</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    Deliver memorable, efficient dining experiences in
                    any venue. With data at their fingertips, servers
                    know guest seating choices, food preferences,
                    allergies, personal celebrations and more.{'\n\n'}
                </div>
                <div className="std-text">
                    InfoGenesis POS empowers guests to order in a
                    simple conversational fashion, then forwards
                    their orders to the kitchen for efficient preparation
                    and staging so their meal is exactly the way they
                    want it.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Restaurant", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                    <img src={InfoGenesis} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Restaurant", "IG Fly");
                    addFlow("IG Fly");
                    navigate("/solutions/ig-fly")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Fly
                    </div>
                    <img src={Fly} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Restaurant", "Reserve");
                    addFlow("Reserve");
                    navigate("/solutions/reserve")}}>
                    <div className="item-head">
                        <LogoMini />
                        Reserve
                    </div>
                    <img src={Reserve} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Restaurant", "IG OnDemand");
                    addFlow("IG On Demand");
                    navigate("/solutions/ig-on-demand")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG OnDemand
                    </div>
                    <img src={OnDemand} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Restaurant", "IG Smart Menu");
                    addFlow("IG Smart Menu");
                    navigate("/solutions/ig-smart-menu")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Smart Menu
                    </div>
                    <img src={SmartMenu} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Restaurant", "IG Quick Pay");
                    addFlow("IG Quick Pay");
                    navigate("/solutions/ig-quick-pay")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Quick Pay
                    </div>
                    <img src={QuickPay} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default RestaurantPage;